import type { DemoKey } from '../types';

export const hi: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'गणित · सांख्यिकी',
  'app.title': 'सांख्यिकी',
  'panel.experiment': 'दृश्य',
  'panel.params': 'पैरामीटर',

  'exp.survey-explorer.title': 'सर्वे एक्सप्लोरर',
  'exp.survey-explorer.desc': 'एक कॉलम चुनें; डेमो उपयुक्त सारांश चुनता है।',
  'exp.distribution-sculptor.title': 'वितरण शिल्पकार',
  'exp.distribution-sculptor.desc':
    'बिंदुओं को खींचें और देखें कि सांख्यिकी कैसे प्रतिक्रिया करती है।',
  'exp.two-variable-lab.title': 'द्विचर प्रयोगशाला',
  'exp.two-variable-lab.desc': 'स्कैटर, फिट, और कारण-कार्य का प्रश्न।',
  'exp.sampling-lab.title': 'प्रतिचयन प्रयोगशाला',
  'exp.sampling-lab.desc': 'तकनीक और आकार नमूना माध्य को कैसे हिलाते हैं।',
  'exp.probability-diagrams.title': 'प्रायिकता आरेख',
  'exp.probability-diagrams.desc': 'संयुक्त घटनाओं के वेन और वृक्ष दृश्य।',

  'type.qualitative-nominal.label': 'गुणात्मक · नामिक',
  'type.qualitative-nominal.def': 'अंतर्निहित क्रम के बिना श्रेणियाँ।',
  'type.qualitative-ordinal.label': 'गुणात्मक · क्रमिक',
  'type.qualitative-ordinal.def': 'सार्थक क्रम वाली श्रेणियाँ।',
  'type.qualitative-multi.label': 'गुणात्मक · बहु-मान',
  'type.qualitative-multi.def': 'प्रत्येक प्रेक्षण में कई टैग हो सकते हैं।',
  'type.quantitative-discrete.label': 'मात्रात्मक · विविक्त',
  'type.quantitative-discrete.def': 'निश्चित चरणों में आने वाली संख्याएँ।',
  'type.quantitative-continuous.label': 'मात्रात्मक · सतत',
  'type.quantitative-continuous.def': 'सतत मापे गए अंक।',

  'column.name.label': 'विद्यार्थी नाम',
  'column.height_cm.label': 'ऊँचाई',
  'column.shoe_size_eu.label': 'जूते का साइज़ (EU)',
  'column.study_hours.label': 'अध्ययन घंटे / सप्ताह',
  'column.test_score.label': 'टेस्ट अंक',
  'column.sports_played.label': 'खेले गए खेल',
  'column.eye_color.label': 'आँख का रंग',
  'column.commute_min.label': 'यात्रा',
  'column.grade_year.label': 'कक्षा',
  'column.homework_effort.label': 'गृहकार्य प्रयास',
  'column.ice-cream-sales.label': 'आइसक्रीम बिक्री',
  'column.drownings.label': 'डूबने की घटनाएँ',
  'column.month.label': 'महीना',
  'column.storks.label': 'सारस',
  'column.births.label': 'जन्म',
  'column.country_area_km2.label': 'देश का क्षेत्रफल',
  'column.sleep_hours.label': 'नींद घंटे',
  'column.reaction_ms.label': 'प्रतिक्रिया समय',

  'dataset.master-survey.label': 'कक्षा सर्वे',
  'dataset.master-survey.desc': '30 सिमुलेटेड विद्यार्थी।',
  'dataset.spurious-ice-cream-vs-drownings.label': 'आइसक्रीम बिक्री बनाम डूबने की घटनाएँ',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'दोनों मौसम के साथ उठते-गिरते हैं। डूबने से आइसक्रीम बिक्री नहीं होती।',
  'dataset.spurious-storks-vs-births.label': 'सारस बनाम जन्म',
  'dataset.spurious-storks-vs-births.desc':
    'बड़े देशों में अधिक सारस और अधिक जन्म होते हैं। पक्षी कारण नहीं हैं।',
  'dataset.real-sleep-vs-reaction-time.label': 'नींद बनाम प्रतिक्रिया समय',
  'dataset.real-sleep-vs-reaction-time.desc':
    'अधिक नींद, तेज़ प्रतिक्रिया। एक वास्तविक ऋणात्मक सहसंबंध — और एक संभाव्य तंत्र।',

  'tag.football.label': 'फुटबॉल',
  'tag.basketball.label': 'बास्केटबॉल',
  'tag.volleyball.label': 'वॉलीबॉल',
  'tag.swimming.label': 'तैराकी',
  'tag.none.label': 'कोई नहीं',

  'population.gaussian.label': 'घंटी वक्र',
  'population.right-skewed.label': 'दायीं तरफ झुका',
  'population.bimodal.label': 'द्विशिखर (स्तरों के साथ)',
  'population.uniform.label': 'समरूप',

  'venn.dice-even-or-prime.label': 'पासा: सम या अभाज्य',
  'venn.class-sports-2set.label': 'खेल (2 समुच्चय)',
  'venn.class-sports-3set.label': 'खेल (3 समुच्चय)',
  'venn.custom.label': 'कस्टम',

  'tree.draw-without-replacement.label': 'बिना प्रतिस्थापन',
  'tree.custom.label': 'कस्टम',
  'tree.coin.heads': 'चित',
  'tree.coin.tails': 'पट',
  'tree.draw.start': 'थैला: 2 लाल, 3 नीली',
  'tree.draw.red': 'लाल',
  'tree.draw.blue': 'नीला',
  'tree.custom.start': 'शुरू',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'हिस्टोग्राम',
  'card.cumulative': 'संचयी आवृत्ति',
  'card.box': 'बॉक्स प्लॉट',
  'card.summary': '5-अंक सारांश',
  'card.bar': 'बार चार्ट',
  'card.mode': 'बहुलक',
  'card.tag-frequency': 'टैग आवृत्ति',
  'card.mode-tag': 'शीर्ष टैग',
  'card.empty-no-order': 'लागू नहीं',
  'card.empty-multi': 'लागू नहीं',
  'card.numberline': 'संख्या रेखा',
  'card.scatter': 'स्कैटर',
  'card.description': 'क्या हो रहा है',
  'card.population': 'समष्टि',
  'card.sampling-distribution': 'नमूना माध्य',
  'card.venn': 'वेन',
  'card.tree': 'वृक्ष',
  'card.probabilities': 'प्रायिकताएँ',

  'param.dataset.label': 'डेटा सेट',
  'param.column.label': 'कॉलम',
  'param.bins.label': 'बिन्स',
  'param.shape.label': 'प्रारंभिक आकार',
  'param.show-mean.label': 'माध्य दिखाएँ',
  'param.show-median.label': 'मध्यिका दिखाएँ',
  'param.x-col.label': 'X कॉलम',
  'param.y-col.label': 'Y कॉलम',
  'param.show-regression.label': 'समाश्रयण रेखा',
  'param.show-residuals.label': 'अवशेष',
  'param.show-confounder.label': 'भ्रामक चर दिखाएँ',
  'param.population.label': 'समष्टि',
  'param.technique.label': 'तकनीक',
  'param.sample-size.label': 'नमूना आकार',
  'param.stratum.label': 'स्तर',
  'param.bias.label': 'अभिनति',
  'param.mode.label': 'मोड',
  'param.preset.label': 'प्रीसेट',
  'param.universe.label': 'सर्वसम आकार',
  'param.show-prob.label': 'प्रायिकताएँ दिखाएँ',
  'param.treat-as-numeric.label': 'संख्यात्मक मानें',

  'stat.count': 'गिनती',
  'stat.mean': 'माध्य',
  'stat.median': 'मध्यिका',
  'stat.range': 'परिसर',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'विचलित मान',
  'stat.r': 'पियर्सन r',
  'stat.r2': 'r²',
  'stat.slope': 'ढाल',
  'stat.intercept': 'अंतःखंड',
  'stat.n': 'n',
  'stat.population-mean': 'सच्चा माध्य',
  'stat.latest-sample-mean': 'नमूना माध्य',
  'stat.sample-mean-spread': 'नमूना माध्य SD',
  'stat.sample-count': 'लिए गए नमूने',
  'outlier.upper': 'ऊपरी विचलित',
  'outlier.lower': 'निचले विचलित',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'पुनः नमूना',
  'btn.run-100': '100 नमूने लें',
  'btn.stop': 'रोकें',
  'btn.clear-history': 'इतिहास साफ़ करें',

  'explainer.no-order': 'क्रम नहीं → संचयी, बॉक्स नहीं।',
  'explainer.multi-no-iqr': 'बहु-मान → चतुर्थक / IQR परिभाषित नहीं।',
  'message.no-data': 'कोई डेटा नहीं।',
  'message.needs-quartiles': 'चतुर्थक के लिए ≥4 बिंदु चाहिए।',
  'message.x-zero-variance': 'X का प्रसरण शून्य — कोई रेखा फिट नहीं।',
  'message.n-too-small': 'n बहुत छोटा।',
  'message.stratum-clamp': 'स्तर में अपेक्षित से कम पंक्तियाँ थीं — सब उपयोग कीं।',
  'message.siblings-sum-to-one': 'भाई-बहन का योग 1 होना चाहिए।',
};
